import React from "react";
import _ from "lodash";
import Cookies from "js-cookie";

import { ATTRS_LABEL } from "@laigu/constants";
import SystemTag from "../system-tag";

// 缓存已发送的顾客卡片label
const memoLabel = {};

const getName = (data) => {
  if (!data) {
    return "";
  }
  return data?.realname || data?.nickname || data?.agent_nickname || "";
};

const smartGuide = (event) => {
  const { content } = event.body;
  let items = [];

  try {
    const data = JSON.parse(content);
    items = (data && data.record) || [];
  } catch (e) {}
  let result = {
    title: "",
    answers: [],
    cardFields: [],
  };

  const getItem = (item) => {
    switch (item.type) {
      case "name":
        return { title: item.content };
      case "message":
        return [
          {
            label: item.content,
            value: item.answer,
          },
        ];
      case "card":
        return (item.content.fields || []).map((f) => ({
          label: ATTRS_LABEL[f.name]
            ? ATTRS_LABEL[f.name]
            : f.display_name || f.name,
          value: 1,
        }));
      default:
        return null;
    }
  };

  if (items && items.length) {
    result = items.reduce((prev, now) => {
      const { type } = now;
      const item = getItem(now);
      if (type === "name") {
        return {
          ...prev,
          ...item,
        };
      }
      if (type === "message") {
        return {
          ...prev,
          answers: [...prev.answers, ...item],
        };
      }
      if (type === "card") {
        return {
          ...prev,
          cardFields: [...prev.cardFields, ...item],
        };
      }
      return prev;
    }, result);
    // 去掉后面的重复项，以后有字段值方便获取最新字段
    const { cardFields } = result;
    result.cardFields = _.reverse(_.unionBy(_.reverse(cardFields), "label"));
  }
  return result;
};

// 将秒数转换为可读的时间格式
const formatSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}小时`);
  if (minutes > 0) parts.push(`${minutes}分钟`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs}秒`);

  return parts.join("");
};

const handleStream = (
  stream,
  options,
  agentListAll,
  containerId,
  ended = false,
  listType = "",
) => {
  const {
    action,
    content_type = "event",
    content,
    extra,
    created_on,
    from_type,

    fail,
    body = {},
    media_url,
    progress,
    fileStatus,
    type,
    id,
    agentName,
    agent_nickname,
    realname,
    selfMessage,
    customExtra,
    read_status,
    agent_id,
    errorMsg,
    translate,
    speechToTxt,
    source,
  } = stream;

  const {
    redirected_by,
    to,
    from,
    attrs,
    new_status,
    to_agent,
    eva_type,
    level,
    content: bodyContent,
    conversation_id: convId,
  } = body;
  const agent = agentListAll?.find((x) => x.id === agent_id) || {};
  let data = {
    agentName: agentName || realname || agent_nickname || getName(agent),
    read_status,
    action,
    msgType: type, // 区分内部消息
    fromType: from_type,
    contentType: content_type,
    time: created_on,
    fail,
    id,
    selfMessage,
    extra,
    translate,
  };

  /**
   * 增加三方平台的数据多样性
   * 三方平台的消息 可存在extra字段
   * extra:
   *  - from_platform: '360' | ''
   *  - content: '文本内容'
   */
  if (content_type === "text") {
    // change wangxing 容错处理
    let config = {};
    let prods = {};
    const prod =
      config.status === "open" && content ? prods[content.trim()] : null;

    if (prod) {
      data = {
        ...data,
        content: [
          {
            type: "product_card",
            size: config.style,
            body: {
              ...prod,
            },
          },
        ],
        noBaseStyle: `true`,
      };
    } else {
      data = {
        ...data,
        content: [
          {
            type: "text",
            body: content,
          },
        ],
      };
      const transData = extra?.translation;
      if (from_type === "agent" && transData) {
        data = {
          ...data,
          translate: {
            targetLanguage: transData?.to,
            sourceLanguage: transData?.from,
            translated: transData?.result,
          },
        };
      }
    }
  }

  if (content_type === "rich_text") {
    data = {
      ...data,
      content: [
        {
          type: "rich_text",
          body: extra && extra.content,
        },
      ],
    };
  }

  if (content_type === "photo") {
    data = {
      ...data,
      content: [
        {
          type: "file",
          body: {
            fileName: content,
            content,
            type: "image",
            url: media_url,
            fileStatus: fileStatus || "success",
            progress,
            errorMsg,
          },
        },
      ],
    };
  }

  if (content_type === "file") {
    data = {
      ...data,
      content: [
        {
          type: "file",
          body: {
            fileName: extra && extra.filename,
            content,
            type: "file",
            url: media_url,
            fileStatus: fileStatus || "success",
            isDownload: !!(extra && extra.first_downloaded_on),
            progress,
          },
        },
      ],
    };
  }

  if (content_type === "audio") {
    data = {
      ...data,
      speechToTxt: speechToTxt,
      content: [
        {
          type: "audio",
          body: {
            mediaUrl: media_url,
          },
        },
      ],
    };
  }

  if (content_type === "video") {
    data = {
      ...data,
      content: [
        {
          type: "video",
          body: {
            fileName: extra && extra.filename,
            fileStatus: fileStatus || "success",
            mediaUrl: media_url,
            thumbUrl: extra && extra.thumb_url,
            progress,
          },
        },
      ],
    };
  }

  if (content_type === "bot") {
    const { content_robot: contentRobot } = stream;
    let robotContent = [];
    if (contentRobot && Array.isArray(contentRobot)) {
      contentRobot.forEach((msg) => {
        if (msg.rich_text) {
          robotContent = [
            ...robotContent,
            { type: "rich_text", body: msg.rich_text },
          ];
        } else if (msg.text) {
          robotContent = [...robotContent, { type: "text", body: msg.text }];
        }
        if (msg.items) {
          /**
           * 由于机器人常见问题 高级设置 存在分组的情况 会导致数据量 变多
           * 暂时处理方法 限制最多展示10条
           */
          const items = msg.items.slice(0, 10);
          robotContent = [...robotContent, { type: "items", body: items }];
        }
      });
    } else {
      /**
       * 兼容后端数据返回异常情况
       * 部分报错情况下 机器人返回的数据格式异常
       * 此时前端需要做容错处理
       * 直接写死错误信息
       */
      robotContent = [
        {
          type: "text",
          body: "机器人出了一点问题，正在为你转接其他客服",
        },
      ];
    }

    data = { ...data, content: robotContent };
  }

  /*
   * AI数字员工 + 用户反馈是按钮的情况 需要过滤
   * content_type == 'hybrid' , extra.conv_type == 'mpush_clue'
   *
   */

  // 解决小红书需求，AI数字员工处理笔记消息不显示的问题
  if (
    source !== "redbook" &&
    source !== "douyin" &&
    content_type === "hybrid" &&
    extra?.conv_type === "mpush_clue"
  ) {
    return null;
  }

  if (content_type === "hybrid") {
    let result = [];
    try {
      result = JSON.parse(content);
      const [msg] = result;
      const { productCard } = options;
      let config = {};
      if (productCard) {
        config = productCard.config || {};
      }
      if (msg.type === "product_card") {
        result = [
          {
            size: config.style,
            ...msg,
          },
        ];
      } else if (msg.type === "redbook_msg") {
        result = [
          {
            type: msg.type,
            body: msg.data,
          },
        ];
      } else if (
        msg.type === "retain_consult_card" ||
        msg.type === "question_guide_msg_card" ||
        msg.type === "douyin_premium_online_appointment_card" ||
        msg.type === "douyin_leads_phone_card"
      ) {
        result = [
          {
            type: msg.type,
            body: msg.data,
          },
        ];
      }
    } catch (e) {}
    data = {
      ...data,
      content: result,
    };
  }

  if (content_type === "event") {
    const streamName = getName(stream);
    // 处理事件内容
    const {
      name,
      color,
      conv_initiate_type,
      unmatch_redirect,
      added_tag,
      deleted_tag,
      old_attrs,
      hit_redirect_keyword,
    } = body;
    switch (action) {
      case "bcp_offline":
        data.content = body?.content;
        break;
      case "getTime":
        data.content = `${created_on}`;
        break;
      case "agent_redirect":
        data.content = `${getName(redirected_by)} ${"转接对话给"} ${getName(to)}`;
        data.eventType = "agent_redirect";
        data.show_summary_btn = to.id === parseInt(Cookies.get("_agent_id"));
        data.convId = convId;
        data.ended = ended;
        data.listType = listType;
        break;
      case "client_redirect":
        data.content = `顾客主动选择与 ${getName(to)} 对话`;
        break;
      case "bot_redirect_auto":
      case "bot_redirect_unsolved":
        data.content = "机器人未识别转人工";
        break;
      case "bot_redirect_manual":
      case "bot_redirect_force":
        data.content = "顾客手动转人工";
        break;
      case "bot_redirect_keyword":
        data.content = `顾客输入关键词${hit_redirect_keyword ? `【${hit_redirect_keyword}】` : ""}转接人工`;
        break;
      case "mbot_interrupt_status_changed":
        if (body.status === "recovered") {
          data.content = "AI员工已恢复接待";
        } else {
          // cate: 1 表示画布；6 表示智能任务
          if (body.cate === 1) {
            data.content = "接收到三方平台消息，AI员工自动转人工";
          } else {
            const recoveryTime = formatSeconds(body.recovery_seconds || 0);
            data.content = `AI员工接待被三方平台消息中断，${recoveryTime}后将自动恢复接待`;
          }
        }
        break;
      case "bot_redirect_mpush":
        data.content = "AI数字员工转人工";
        break;
      case "bot_redirect_other":
        data.content = "转人工";
        break;
      case "system_redirect":
        data.content = `由于客服不在线, 对话被自动转接给 ${getName(to)}`;
        break;
      case "timeout_redirect":
        data.content = `由于 ${getName(from)} 未及时回复, 对话被自动转接给 ${getName(to)}`;
        break;
      case "visit_inviting":
        data.content = `${streamName} 邀请顾客对话`;
        break;
      case "client_change_attr":
        // 目前只用于回呼提交电话号码
        data = {
          ...data,
          eventType: "clientUpdateCardField",
          content:
            Object.keys(attrs).map((k) => {
              return {
                label: k,
                value: attrs[k],
                oldValue: old_attrs[k] || null,
              };
            }) || [],
        };
        break;
      case "agent_change_attr":
        data = {
          ...data,
          agentName: streamName,
          eventType: "agentUpdateCardField",
          content:
            Object.keys(attrs).map((k) => {
              return {
                label: k,
                value: attrs[k],
                oldValue: old_attrs[k] || null,
              };
            }) || [],
        };
        break;
      case "init_conv":
        const { visit_info, title, url } = body;
        const isSmartGuide = conv_initiate_type === "smart_guide";
        const isConvByHistory = conv_initiate_type === "created_by_history";
        data = {
          ...data,
          eventType: "initConv",
          extra: {
            visit_info,
            title,
            url,
          },
        };
        data.content = "顾客主动发起对话";
        if (isConvByHistory) {
          const createConvAgent = agentListAll.find(
            (a) => a.id === body.agent_id,
          );
          data.content = `${getName(createConvAgent)}从历史对话页新建对话`;
        }
        if (isSmartGuide) {
          data.content = "顾客由智能引导转接对话";
        }
        if (conv_initiate_type === "created_by_auto_follow") {
          data.content = body.initiate_name
            ? `${body.initiate_name}-${"自动追粉"}`
            : "自动追粉";
        }
        if (unmatch_redirect) {
          data.content = "机器人未识别，自动转接";
        }
        if (hit_redirect_keyword) {
          data.content = `顾客输入关键词【${hit_redirect_keyword}】转接人工`;
        }
        break;
      case "end_conv_agent":
        if (body.ended_by === "channel_blacklist") {
          data.content = `${streamName} 拉黑了用户，对话自动结束`;
        } else {
          data.content = `${streamName} 结束了对话`;
        }
        break;
      case "end_conv_timeout":
        data.content = "对话超时，系统自动结束对话";
        break;
      case "end_conv_baidu_robot":
        data.content = "百度主动结束对话";
        break;
      case "end_conv_client":
        data.content = "系统自动结束对话";
        break;
      case "ticket_status_change":
        data.content = `${streamName} 把留言标记成了已解决`;
        if (new_status === "open") {
          data.content = `${streamName} 重新打开了留言`;
        }
        break;
      case "ticket_redirect":
        data.content = `${streamName} 把留言指派给 ${to_agent}`;
        break;
      case "invite_evaluation":
        data.content = `${streamName} ${"发送了评价邀请"}`;
        break;
      case "client_evaluation":
        data = {
          ...data,
          eventType: "evalution",
          evaType: eva_type,
          level,
          content: bodyContent,
          resolved: body.resolved,
        };
        break;
      case "client_add_tag":
        data.content = (
          <div>
            <span style={{ margin: "0 10px 0 0" }}>
              {streamName} {"添加顾客标签"}
            </span>
            <SystemTag data={{ name, color }} />
          </div>
        );
        break;
      case "client_remove_tag":
        data.content = (
          <div>
            <span style={{ margin: "0 10px 0 0" }}>
              {streamName} {"删除顾客标签"}
            </span>
            <SystemTag data={{ name, color }} />
          </div>
        );
        break;
      case "update_conv_tag":
        data = {
          ...data,
          eventType: "agentUpdateConvTag",
          content: { deleted_tag, added_tag },
        };
        break;
      case "switch_human":
        data.content = "无客服在线对话转接失败，系统结束对话";
        break;
      case "summary_button":
        data.content = "对话小结";
        break;
      case "agent_send_card":
        const fields1 =
          bodyContent.map((c) => {
            const name = ATTRS_LABEL[c.name]
              ? ATTRS_LABEL[c.name]
              : c.display_name || c.name;
            memoLabel[c.name] = name;
            return { name, value: c.name };
          }) || [];
        data = {
          ...data,
          eventType: "cardField",
          subType: "ask",
          content: fields1,
        };
        break;
      case "client_reply_card":
        data = {
          ...data,
          eventType: "cardField",
          subType: "get",
          content:
            Object.keys(attrs).map((k) => {
              return { label: memoLabel[k] || k, value: attrs[k] };
            }) || [],
        };
        break;
      case "mpush_clue":
        data = {
          ...data,
          eventType: "intelligenceGuidance",
          content: smartGuide(stream),
        };
        break;
      case "visit_black_add":
        data.content = `${streamName} ${"拉黑访客"}`;
        break;
      case "visit_black_del":
        data.content = `${streamName} ${"移除访客黑名单"}`;
        break;
      case "visit_black_approve":
        data.content = `${streamName} ${"申请拉黑访客"}`;
        break;
      case "visit_black_reject":
        data.content = `${streamName} ${"拒绝拉黑访客申请"}`;
        break;
      case "withdraw_msg":
        data.eventType = "withdraw";
        data.withdrawContent = body.msg_content;
        data.content = `${streamName} ${"撤回了一条消息"}`;
        break;
      case "client_withdraw_msg":
        data.eventType = "withdraw";
        data.withdrawContent = body.msg_content;
        data.content = `${"顾客"}${"撤回了一条消息"}`;
        break;
      case "agent_send_sensitive_words":
        data.eventType = "agentSendSensitiveWords";
        if (streamName) {
          data.content = body.content
            ? `${streamName}的消息因包含企业敏感词「${body.content}」发送失败`
            : `${streamName}的消息因包含敏感词发送失败`;
        } else {
          data.content = body.content
            ? `消息因包含企业敏感词「${body.content}」发送失败`
            : "消息因包含敏感词发送失败";
        }
        data.rawContent = body.raw_content;
        data.rawType = body.content_type;
        if (!containerId) {
          data.isEdit = body?.raw_content && body?.content_type === "text";
        }
        break;
      case "send_message_fail":
        data.content = bodyContent;
        break;
      case "allocate_delayed": // 无消息访客过滤进入对话
        data.content = bodyContent;
        break;
      case "prechat_survey": // 顾客通过询前表单选择
        data.content = bodyContent;
        break;
      case "copy_statistics": {
        data.content = "顾客点击复制按钮";
        data.eventType = "copy_statistics";
        data.body = body;
        break;
      }
      case "open_mass_message": {
        data.content = "顾客点击群发消息" + "：" + body.mass_message_name;
        data.body = body;
        break;
      }
      case "end_trusteeship": {
        data.content = `${streamName} 关闭对话托管`;
        break;
      }
      case "quick_btn_click":
        {
          data.content = body;
          data.eventType = "quick_btn_click";
        }
        break;
      case "conv_redirect_summary":
        data.content = body;
        data.eventType = "conv_redirect_summary";
        break;
      case "channel_hint":
        data.content = body.content;
        break;
      case "phone_check":
        data.content = body;
        data.eventType = "phone_check";
        break;
      case "wechat_copy":
        data.content = body;
        data.eventType = "wechat_copy";
        break;
      case "msg_app_open":
        data.content = body;
        data.eventType = "msg_app_open";
        break;
      default:
    }
  }

  // 自定义的属性
  if (customExtra) {
    return {
      customExtra,
      ...data,
    };
  }

  return data;
};

export default handleStream;
